import * as React from 'react'
import { cn } from '@/lib/utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Visually marks the input as invalid */
  error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Base — 44px height for touch target, amber focus ring
          'flex h-11 w-full rounded-xl border bg-[var(--c-bg-panel)] px-3 py-2 text-base md:text-sm',
          'text-[var(--c-text-1)] placeholder:text-[var(--c-text-3)]',
          'ring-offset-background',
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--c-border-focus)] focus-visible:ring-offset-0',
          'disabled:cursor-not-allowed disabled:opacity-50',
          // Normal border
          !error && 'border-[var(--c-border)]',
          // Error state — red border + red focus ring
          error && 'border-[var(--c-border-err)] focus-visible:ring-[var(--c-border-err)]',
          className,
        )}
        ref={ref}
        aria-invalid={error ? true : undefined}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
